import React from 'react';

import styles from './styles.module.scss';

interface IStatusBar {
  totalRewards: number;
  totalRewardAmount: string;
  isInAppCm: boolean;
}

const StatusBar = ({
  totalRewards,
  totalRewardAmount,
  isInAppCm,
}: IStatusBar) => (
  <div className={styles.wrapper} data-testid="rewards-status-bar">
    <div className={styles.header}>
      <div className={styles.value}>{totalRewards}</div>
      <div className={styles.label}>
        Total
        <br />
        Rewards
        <br />
        (Current Rx)
      </div>
    </div>
    {isInAppCm && (
      <div className={styles.header}>
        <div className={styles.value} data-testid="total-rewards-value">
          {totalRewardAmount}
        </div>
        <div className={styles.label}>
          Total Reward
          <br />
          Amount
          <br />
          (Current Rx)
        </div>
      </div>
    )}
  </div>
);

export default StatusBar;
